module.exports = __webpack_public_path__ + "img/橫向LOGO.45cf7563.png";